import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStars = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 15,
	viewBox: "0 0 17 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.41667 10.75V14.0833M3.25 0.75V4.08333M4.08333 12.4167H0.75M4.91667 2.41667H1.58333M9.08333 0.75L10.544 4.45364C10.7006 4.85069 10.7789 5.04922 10.8988 5.21662C11.0051 5.365 11.135 5.49492 11.2834 5.60119C11.4508 5.72108 11.6493 5.79938 12.0464 5.95597L15.75 7.41667L12.0464 8.87736C11.6493 9.03396 11.4508 9.11225 11.2834 9.23214C11.135 9.33841 11.0051 9.46833 10.8988 9.61672C10.7789 9.78412 10.7006 9.98264 10.544 10.3797L9.08333 14.0833L7.62264 10.3797C7.46604 9.98264 7.38775 9.78412 7.26786 9.61672C7.16159 9.46833 7.03167 9.33841 6.88328 9.23214C6.71588 9.11225 6.51736 9.03396 6.12031 8.87736L2.41667 7.41667L6.12031 5.95597C6.51736 5.79938 6.71588 5.72108 6.88328 5.60119C7.03167 5.49492 7.16159 5.365 7.26786 5.21662C7.38775 5.04922 7.46604 4.85069 7.62264 4.45364L9.08333 0.75Z",
		stroke: "#00B398",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgStars;
